import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { HelpersService } from '../../../../../services/helpers.service';
import { PartnerService } from '../../../../../services/partner.service';
import { AppConfig } from '../../../../../app.config';
import { ConfirmationService } from 'primeng/api';
import { ServiceTypeService } from '../../../../../services/service-type.service';

@Component({
  selector: 'app-service-type-message-template',
  templateUrl: './service-type-message-template.component.html',
  styleUrls: ['./service-type-message-template.component.scss'],
})
export class ServiceTypeMessageTemplateComponent implements OnInit {
  @Input() selectedMessageTemplate;
  @Input() messageTemplates;
  @Output() closePanel = new EventEmitter();

  public partnerId = 0;
  public messageTemplate: any = {};
  public originalMessageTemplate: any = {};
  public saving: boolean = false;
  public classicTemplate = false;
  public screenHeight: number = 0;
  public partner: any = {};
  public templateImport: any = null;
  public filteredMessageTemplates: any = [];

  public appearance: any = {
    theme: 'light',
    panels: {
      tools: {
        dock: 'left',
      },
    },
  };
  public options: any = {
    id: 'editor-container',
    displayMode: 'email',
    safeHtml: true,
    //{},
    mergeTags: {
      partner_name: {
        name: 'Shop Name',
        value: '$Partner.Name$',
      },
      partner_freetext: {
        name: 'Shop Free Text',
        value: '$Partner.FreeText$',
      },
      item_manufacturer: {
        name: 'Manufacturer',
        value: '$Item.Manufacturer$',
      },
      customer_name: {
        name: 'Customer Name',
        value: '$Customer.Name$',
      },
      phone_number: {
        name: 'Customer Phone Number',
        value: '$Partner.PhoneNumber1$',
      },
      scheduled_date: {
        name: 'Booking Date',
        value: '$Service.ScheduledDate$',
      },
      scheduled_date_time: {
        name: 'Booking Date with Time',
        value: '$Service.ScheduledDateTime$',
      },
      sheduled_time: {
        name: 'Booking Time',
        value: '$Time$',
      },
      referral_code: {
        name: 'Referral Code',
        value: '$ReferralCode$',
      },
      referral_balance: {
        name: 'Refferal Balance',
        value: '$ReferralBalance$',
      },
      checklists: {
        name: 'Checklist',
        value: '$ChecklistItems$',
      },
      workshop_address: {
        name: 'Workshop Address',
        value: '$Workshop.Address$',
      },
    },
    designTags: {
      partner_logo: this.helpersService.getPartnerData().ImageURL,
    },
    designTagsConfig: {
      delimiter: ['[[', ']]'],
    },
  };

  constructor(
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    public messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    public appConfig: AppConfig,
    private serviceTypeService: ServiceTypeService,
  ) {
    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();
  }

  @ViewChild(EmailEditorComponent)
  private emailEditor: EmailEditorComponent;

  ngOnInit() {
    //this.filteredMessageTemplates = this.messageTemplates.filter(x=>{return x.TemplateDesign !== null && x.TemplateDesign.length > 0 && x.id !== this.selectedMessageTemplate}).map(x=>{return {label: this.translate.instant(x.eventTag+'_title', {ServiceFollowUpReminderMonths : this.partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService : this.partner.ReminderHoursBeforeService, WaitingDelayHours : this.partner.WaitingDelayHours}) ,value: x.TemplateDesign}});
    this.filteredMessageTemplates = this.messageTemplates
      .filter((x) => {
        return (
          x.Template &&
          x.Template.length > 0 &&
          x.EventTag.indexOf('service.') > -1
        );
      })
      .sort((x, y) => {
        if (
          this.translate.instant(x.EventTag + '_title') <
          this.translate.instant(y.EventTag + '_title')
        ) {
          return -1;
        } else if (
          this.translate.instant(x.EventTag + '_title') >
          this.translate.instant(y.EventTag + '_title')
        ) {
          return 1;
        } else {
          return 0;
        }
      })
      .map((x) => {
        return {
          label: this.translate.instant(x.EventTag + '_title', {
            ServiceFollowUpReminderMonths:
              this.partner.ServiceFollowUpReminderMonths,
            ReminderHoursBeforeService: this.partner.ReminderHoursBeforeService,
            WaitingDelayHours: this.partner.WaitingDelayHours,
            OtherServiceFollowUpReminderMonths:
              this.partner.OtherServiceFollowUpReminderMonths,
            PostServiceFollowUpDays: this.partner.PostServiceFollowUpDays,
          }),
          value: { TemplateDesign: x.TemplateDesign, Template: x.Template },
        };
      });
    this.getMessageTemplate();
    this.screenHeight = window.innerHeight;
  }

  listMergeTags() {
    var list = [];
    for (var tag in this.options.mergeTags) {
      list.push(this.options.mergeTags[tag]);
    }
    return list;
  }

  getMessageTemplate() {
    this.messageTemplate = {};

    this.messageTemplate = this.selectedMessageTemplate;
    this.originalMessageTemplate = JSON.parse(
      JSON.stringify(this.selectedMessageTemplate),
    );

    if (
      this.messageTemplate.eventTag === 'service.complete' ||
      this.messageTemplate.eventTag === 'service.start' ||
      this.messageTemplate.eventTag === 'service.waitingforclient' ||
      this.messageTemplate.eventTag === 'service.waitingforparts' ||
      this.messageTemplate.eventTag === 'service.warranty'
    ) {
      this.options.mergeTags['job_card_link'] = {
        name: 'Job Card Link',
        value: '$url$',
      };
    }

    if (
      this.messageTemplate.eventTag === 'service.pickup' ||
      this.messageTemplate.eventTag === 'service.bookin'
    ) {
      this.options.mergeTags['reschedule_link'] = {
        name: 'Reschedule Link',
        value: '$RescheduleLink$',
      };
    }

    if (
      this.messageTemplate.eventTag === 'service.approval' ||
      this.messageTemplate.eventTag === 'service.multiapproval'
    ) {
      this.options.mergeTags['approval_link'] = {
        name: 'Approval Link',
        value: '$url$',
      };
    }
    if (
      this.messageTemplate.eventTag === 'rentals.booked' ||
      this.messageTemplate.eventTag === 'rentals.sendwaiver' ||
      this.messageTemplate.eventTag === 'rentals.waiversigned'
    ) {
      this.options.mergeTags['reservation_date'] = {
        name: 'Rental Reservation Date',
        value: '$Rentals.ReservationDate$',
      };
      this.options.mergeTags['waiver_url'] = {
        name: 'Waiver URL',
        value: '$Rentals.WaiverURL$',
      };
    }
    if (this.messageTemplate.eventTag === 'rentals.waiversigned') {
      this.options.mergeTags['waiver'] = {
        name: 'Waiver & Signature',
        value: '$waiver$',
      };
    }
    if (this.messageTemplate.eventTag === 'service.deliverybooked') {
      this.options.mergeTags['delivery_booked'] = {
        name: 'Delivery Booked URL',
        value: '$Delivery.URL$',
      };
    }
    this.editorLoaded();
  }

  saveTemplate() {
    this.saving = true;
    if (this.emailEditor) {
      this.emailEditor.saveDesign((design) => {
        this.messageTemplate.templateDesign = JSON.stringify(design);
        this.emailEditor.exportHtml((html) => {
          this.messageTemplate.emailTemplate = html['html'];
          this.save();
        });
      });
    } else {
      this.save();
    }
  }

  save() {
    this.serviceTypeService
      .updateServiceTypeMessageTemplates(this.messageTemplate)
      .subscribe(
        (template) => {
          this.messageTemplate.id = template.id;
          this.saving = false;
          this.closePanel.emit();
          this.messageService.add({
            life: 5000,
            summary: this.translate.instant(
              'bikeshop.message_templates.template_updated',
            ),
            detail: this.translate.instant(
              'bikeshop.message_templates.message_updated',
              { EventTag: this.messageTemplate.eventTag },
            ),
          });
        },
        (err) => {
          this.saving = false;
        },
      );
  }

  editorLoaded() {
    if (this.emailEditor && this.emailEditor.editor) {
      if (
        this.messageTemplate.templateDesign &&
        JSON.parse(this.messageTemplate.templateDesign).counters
      ) {
        this.emailEditor.editor.loadDesign(
          JSON.parse(this.messageTemplate.templateDesign),
        );
        this.classicTemplate = false;
      } else if (
        this.messageTemplate.emailTemplate &&
        this.messageTemplate.emailTemplate.length > 0
      ) {
        this.emailEditor.editor.loadDesign({
          html: this.messageTemplate.emailTemplate,
          classic: true,
        });
        this.classicTemplate = true;
      } else {
        this.emailEditor.editor.loadDesign({
          counters: { u_column: 1, u_row: 1, u_content_html: 1 },
          body: {
            rows: [
              {
                cells: [1],
                columns: [
                  {
                    contents: [],
                    values: {
                      backgroundColor: '',
                      padding: '0px',
                      border: {},
                      _meta: {
                        htmlID: 'u_column_1',
                        htmlClassNames: 'u_column',
                      },
                    },
                  },
                ],
                values: {
                  displayCondition: null,
                  columns: false,
                  backgroundColor: '',
                  columnsBackgroundColor: '',
                  backgroundImage: {
                    url: '',
                    fullWidth: true,
                    repeat: false,
                    center: true,
                    cover: false,
                  },
                  padding: '0px',
                  hideDesktop: false,
                  hideMobile: false,
                  noStackMobile: false,
                  _meta: { htmlID: 'u_row_1', htmlClassNames: 'u_row' },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                },
              },
            ],
            values: {
              backgroundColor: '#ffffff',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: false,
                center: true,
                cover: false,
              },
              contentWidth: '500px',
              contentAlign: 'center',
              fontFamily: {
                label: 'Arial',
                value: 'arial,helvetica,sans-serif',
              },
              preheaderText: '',
              linkStyle: {
                body: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              _meta: { htmlID: 'u_body', htmlClassNames: 'u_body' },
            },
          },
          schemaVersion: 5,
        });
        this.classicTemplate = false;
      }

      this.emailEditor.editor.registerCallback('image', (file, done) => {
        let uploadFile = file.attachments[0];

        var reader = new FileReader();
        reader.readAsDataURL(uploadFile);
        reader.onload = (file: any) => {
          let data = {
            Image: file.target.result,
            Folder: 'partnerphotos',
            Type: 'MessageTemplateImage',
          };

          this.partnerService
            .uploadImage(data, this.partnerId)
            .subscribe((result) => {
              console.log(result);
              done({ url: result });
            });
        };
      });
    }
  }

  resetTemplate() {
    this.confirmationService.confirm({
      key: 'add_edit_message_templates',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.message_templates.convert_template_header',
      ),
      message: this.translate.instant(
        'bikeshop.message_templates.convert_template',
      ),
      accept: () => {
        this.emailEditor.editor.loadDesign({
          counters: { u_column: 1, u_row: 1, u_content_html: 1 },
          body: {
            rows: [
              {
                cells: [1],
                columns: [
                  {
                    contents: [],
                    values: {
                      backgroundColor: '',
                      padding: '0px',
                      border: {},
                      _meta: {
                        htmlID: 'u_column_1',
                        htmlClassNames: 'u_column',
                      },
                    },
                  },
                ],
                values: {
                  displayCondition: null,
                  columns: false,
                  backgroundColor: '',
                  columnsBackgroundColor: '',
                  backgroundImage: {
                    url: '',
                    fullWidth: true,
                    repeat: false,
                    center: true,
                    cover: false,
                  },
                  padding: '0px',
                  hideDesktop: false,
                  hideMobile: false,
                  noStackMobile: false,
                  _meta: { htmlID: 'u_row_1', htmlClassNames: 'u_row' },
                  selectable: true,
                  draggable: true,
                  duplicatable: true,
                  deletable: true,
                },
              },
            ],
            values: {
              backgroundColor: '#ffffff',
              backgroundImage: {
                url: '',
                fullWidth: true,
                repeat: false,
                center: true,
                cover: false,
              },
              contentWidth: '500px',
              contentAlign: 'center',
              fontFamily: {
                label: 'Arial',
                value: 'arial,helvetica,sans-serif',
              },
              preheaderText: '',
              linkStyle: {
                body: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              _meta: { htmlID: 'u_body', htmlClassNames: 'u_body' },
            },
          },
          schemaVersion: 5,
        });
        this.classicTemplate = false;
      },
    });
  }

  cancel() {
    this.closePanel.emit();
  }

  templateChanged() {
    return !this.deepEqual(this.messageTemplate, this.originalMessageTemplate);
  }

  deepEqual = (x, y) => {
    return x && y && typeof x === 'object' && typeof y === 'object'
      ? Object.keys(x).length === Object.keys(y).length &&
          Object.keys(x).reduce((isEqual, key) => {
            return isEqual && this.deepEqual(x[key], y[key]);
          }, true)
      : x === y;
  };

  importDesign() {
    this.messageTemplate.emailTemplate = '';
    this.messageTemplate.templateDesign = null;
    this.editorLoaded();
    this.messageTemplate.emailTemplate = JSON.parse(
      JSON.stringify(this.templateImport.Template),
    );
    this.messageTemplate.templateDesign =
      this.templateImport.TemplateDesign === '{}'
        ? null
        : JSON.parse(JSON.stringify(this.templateImport.TemplateDesign));
    this.originalMessageTemplate = JSON.parse(
      JSON.stringify(this.templateImport.Template),
    );
    this.editorLoaded();
    this.templateImport = null;
  }

  disableMessaging() {
    if (this.messageTemplate.disableMessaging) {
      this.messageTemplate.shortMessageTemplateActive = false;
      this.messageTemplate.emailTemplateActive = false;
    }
  }
}
